import { FormRowFactory } from '../../../factories/FormRowFactory'
export class Primary {
  constructor() {
    this.name = 'Primary'
    this.content = {
      method: 'POST',
      action: '/',
      hasHoneypot: true,
      showLabels: true,
      showPlaceholder: true,
      leadTags: null,
      sendMail: false,
      sendMailSubject: null,
      toMails: null,
      frontendValidation: false,
      leadList: null,
      hasRecaptcha: false,
      rows: [(new FormRowFactory).create()]
    }
    this.view = this.viewHtml()
  }

  viewHtml() {
    return 'primary'
  }

  classes() {
    return [
      //
    ]
  }

  styles() {
    return [
      //
    ]
  }

  errorInputStyles() {
    return [
      //
    ]
  }

  focusedInputStyles() {
    return [
      //
    ]
  }

  labelClasses() {
    return [
      {property: 'FontSize', value: 'FONT_SIZE_XS'}
    ]
  }

  labelStyles() {
    return [
      //
    ]
  }

  buttonClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_MD'},
      {property: 'InputSize', value: 'INPUT_SIZE_MD'},
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
      {property: 'BorderSideTopWidth', value: 'BORDER_TOP_THIN'},
      {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_THIN'},
      {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_THIN'},
      {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_THIN'},
    ]
  }

  buttonStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #5950eb,#5950eb)'},
      {property:'BorderColor', styleProperty: 'border-color', value: '#43369d'},
      {property:'TextColor', styleProperty: 'color', value: '#ffffff'},
    ]
  }

  inputClasses() {
    return [
      {property: 'Rounded', value: 'ROUNDED_MD'},
      {property: 'InputSize', value: 'INPUT_SIZE_MD'},
      {property: 'BorderStyle', value: 'BORDER_SOLID'},
      {property: 'BorderSideTopWidth', value: 'BORDER_TOP_THIN'},
      {property: 'BorderSideBottomWidth', value: 'BORDER_BOTTOM_THIN'},
      {property: 'BorderSideLeftWidth', value: 'BORDER_LEFT_THIN'},
      {property: 'BorderSideRightWidth', value: 'BORDER_RIGHT_THIN'},
    ]
  }

  inputStyles() {
    return [
      {property:'BackgroundColor', styleProperty: 'background-image', value: 'linear-gradient(0deg, #ffffff,#ffffff)'},
      {property:'BorderColor', styleProperty: 'border-color', value: '#d1d1d1'}
    ]
  }

  buildData() {
    return {
      name: this.name,
      view: this.view,
    }
  }

  editorProperties() {
    return {
      content: this.content,
      errorInputStyles: {
        desktop: this.errorInputStyles(),
        tablet: this.errorInputStyles(),
        phone: this.errorInputStyles(),
      },
      focusedInputStyles: {
        desktop: this.focusedInputStyles(),
        tablet: this.focusedInputStyles(),
        phone: this.focusedInputStyles(),
      },
      buttonClasses: {
        desktop: this.buttonClasses(),
        tablet: this.buttonClasses(),
        phone: this.buttonClasses(),
      },
      buttonStyles: {
        desktop: this.buttonStyles(),
        tablet: this.buttonStyles(),
        phone: this.buttonStyles(),
      },
      labelClasses: {
        desktop: this.labelClasses(),
        tablet: this.labelClasses(),
        phone: this.labelClasses(),
      },
      labelStyles: {
        desktop: this.labelStyles(),
        tablet: this.labelStyles(),
        phone: this.labelStyles(),
      },
      inputClasses: {
        desktop: this.inputClasses(),
        tablet: this.inputClasses(),
        phone: this.inputClasses(),
      },
      inputStyles: {
        desktop: this.inputStyles(),
        tablet: this.inputStyles(),
        phone: this.inputStyles(),
      },
      styles: {
        desktop: this.styles(),
        tablet: this.styles(),
        phone: this.styles(),
      },
      classes: {
        desktop: this.classes(),
        tablet: this.classes(),
        phone: this.classes(),
      },
    }
  }
}